import { render, staticRenderFns } from "./Shutdown.vue?vue&type=template&id=35c24d13&scoped=true&"
import script from "./Shutdown.vue?vue&type=script&lang=js&"
export * from "./Shutdown.vue?vue&type=script&lang=js&"
import style0 from "./Shutdown.vue?vue&type=style&index=0&id=35c24d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c24d13",
  null
  
)

export default component.exports